import Home from "./Home"
import DataMap from "./DataMap"

export { Home, DataMap }

export default Home
